import React from 'react';
import ReactResizeDetector from 'react-resize-detector';
import classnames from 'classnames';

import './underlinedTitle.scss';

class UnderlinedTitle extends React.Component {
    render() {
        return (
            <span className={classnames('underlined-title-wrapper', { 'underlined-title-wrapper-margin-bottom': this.props.marginBottom })} >
                { typeof this.props.onTitleResize === 'function' &&
                    <ReactResizeDetector handleWidth handleHeight onResize={this.props.onTitleResize /* ensure title size changes (e.g. after changing language) */} />
                }
                <span className="underlined-title">{this.props.header}</span>
            </span>
        )
    }
}

export default UnderlinedTitle;